/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_OpenInputs */

const en_gc_editor_open = /** @type {(inputs: Gc_Editor_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in a tab`)
};

const zh_gc_editor_open = /** @type {(inputs: Gc_Editor_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在新标签页打开`)
};

/**
* | output |
* | --- |
* | "Open in a tab" |
*
* @param {Gc_Editor_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_open = /** @type {((inputs?: Gc_Editor_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_open(inputs)
	return zh_gc_editor_open(inputs)
});
export { gc_editor_open as "gc.editor.open" }